import React from 'react';
import { Typography } from '@mui/material';

const SettingsPage: React.FC = () => (
  <div>
    <Typography variant="h4">Settings</Typography>
    <Typography>System settings will be implemented here.</Typography>
  </div>
);

export default SettingsPage;